var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"translate-modal","size":"xl","title":"Choose Your Language","hide-backdrop":"","scrollable":""}},[_c('Translator',{attrs:{"countries":_vm.countries},on:{"on-country-click":_vm.hideModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }